import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: { label: string; onClick: () => void }
}

export default function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 border-2 border-dashed border-slate-700/50 rounded-xl">
      <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4">
        <Icon className="w-7 h-7 text-cyan-500/50" />
      </div>
      <p className="font-mono text-sm text-slate-400 mb-1">{title}</p>
      <p className="font-mono text-xs text-slate-600">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-4 px-4 py-2 rounded-lg font-mono text-xs border border-cyan-500/20 text-cyan-400 hover:bg-cyan-500/10 transition-all duration-150"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
